import { CbhFeatureFlag, useCbhFlag } from "@src/appV2/FeatureFlags";
import { invalidateGetOpenShifts } from "@src/appV2/redesign/Shift/Open/useGetOpenShifts";
import { invalidateGetWorkerQuery } from "@src/appV2/Worker/api/useGetWorker";
import { useQueryClient } from "@tanstack/react-query";
import { secondsToMilliseconds } from "date-fns";

import { useGetWorkerStage } from "../../../Worker/api/useGetWorkerStage";

export function useRefreshOnStageChange() {
  const staleTime = secondsToMilliseconds(5);

  const { enabled } = useCbhFlag(CbhFeatureFlag.SHIFT_DISCOVERY_DETECT_STAGE_CHANGES, {
    defaultValue: { enabled: false },
  });

  const queryClient = useQueryClient();
  useGetWorkerStage({
    onSuccess: async (data) => {
      if (enabled && data.changed) {
        await invalidateGetWorkerQuery(queryClient);
        await invalidateGetOpenShifts(queryClient);
      }
    },
    enabled,
    staleTime,
  });
}
